import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Button from '@inqool/uas-web-core/es/components/controls/Button';

import HelpTooltip from '@components/HelpTooltip/HelpTooltip';
import { EditorField, Editor } from '@components/form';
import { compose, withHandlers, withState } from 'recompose';
import { generatePdf, getDescriptionTemplate, saveDescriptionAsFile } from './_eventsActions';
import { ModalButton } from '@components/modalButton/ModalButton';
import EventsFormDecriptionGenerateForm from '@modules/events/EventsFormDescriptionGenerateForm';
import { connect } from 'react-redux';
import { formValueSelector, change } from 'redux-form';
import EventsFormDescriptionSaveAsFileForm from './EventsFormDescriptionSaveAsFileForm';

const enhance = compose<any, any>(
  connect(
    state => ({
      type: formValueSelector('module-events')(state, 'type'),
      description: formValueSelector('module-events')(state, 'description')
    }),
    dispatch => {
      return { changeDescription: value => dispatch(change('module-events', 'description', value)) };
    }
  ),
  withState('generatedDescription', 'setGeneratedDescription', null),
  withHandlers({
    getTemplate: ({ setGeneratedDescription, eventId }) => async () => {
      const response = await getDescriptionTemplate(eventId);
      setGeneratedDescription(response);
    },
    setTemplate: ({ changeDescription, generatedDescription }) => async closeItem => {
      changeDescription(generatedDescription);
      closeItem();
    },
    handleGenerate: ({ eventId }) => async () => {
      const { id } = await generatePdf(eventId);
      if (id) {
        window.open(`/metropolis/api/files/${id}`, '_blank');
      }
    },
    saveAsFile: ({ description, eventId, reloadEvent }) => async (fileName, closeItem) => {
      const response = await saveDescriptionAsFile(eventId, fileName + '.draft', description);
      if (response) {
        closeItem();
        reloadEvent();
      }
    }
  })
);

const View: React.SFC<any> = ({
  disabled,
  handleGenerate,
  type,
  getTemplate,
  setTemplate,
  description,
  generatedDescription,
  locked,
  saveAsFile
}) => (
  <Grid fluid={true}>
    <Row>
      <Col className="grid-system-margin" />
    </Row>

    <Row>
      <Col md={12}>
        <h4>Hlášení</h4>
      </Col>
    </Row>
    <Row middle="xs">
      <ModalButton
        label="Generovat ze šablony"
        style={{ marginRight: `${(disabled && !locked) || !type ? '0' : '15px'}` }}
        disabled={disabled || !type}
        onClick={getTemplate}
        ModalComponent={EventsFormDecriptionGenerateForm}
        handleSubmit={setTemplate}
        description={description}
        generatedDescription={generatedDescription}
      />
      {((disabled && !locked) || !type) && (
        <HelpTooltip
          help={
            disabled && !locked
              ? 'Před generováním je potřeba uložit změny'
              : 'Pro generování ze šablony je potřeba zvolit typ události'
          }
          tooltipPosition="top-right"
        />
      )}
      <Button label="Generovat PDF" style={{ marginRight: '15px' }} onClick={handleGenerate} disabled={disabled} />
      <ModalButton
        label="Uložit mezi soubory"
        style={{ marginRight: '15px' }}
        disabled={disabled}
        ModalComponent={EventsFormDescriptionSaveAsFileForm}
        handleSubmit={saveAsFile}
      />
    </Row>
    <Row>
      <Col md={12} style={{ padding: 0 }}>
        <EditorField component={Editor} id="description" name="description" label={'Hlášení'} readOnly={locked} />
      </Col>
    </Row>

    <Row>
      <Col className="grid-system-margin" />
    </Row>
  </Grid>
);

export default enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormDescription.tsx